<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>
<div class="fixed top-5 z-9999 w-full">
    <alert></alert>
</div>

<!-- Spotlight -->
<app-spotlight></app-spotlight>

<!-- Navigation -->
<ng-container *ngIf="navigation?.default?.length > 0; else navSkeleton">
    <fuse-vertical-navigation
        class="bg-[#fafcff]"
        [mode]="isScreenSmall ? 'over' : 'side'"
        [name]="'mainNavigation'"
        [navigation]="navigation.default"
        [opened]="!isScreenSmall">
    </fuse-vertical-navigation>
</ng-container>

<ng-template #navSkeleton>
    <div class="flex flex-col w-[280px] min-w-[280px] h-screen bg-[#fafcff] border-r pt-6 px-4">
        <div class="flex items-center gap-3 mb-8 px-2">
            <div class="w-8 h-8 rounded-full bg-gray-200 animate-pulse"></div>
            <div class="h-4 w-24 rounded bg-gray-200 animate-pulse"></div>
        </div>
        <div class="space-y-2">
            <div class="h-8 w-full rounded-lg bg-gray-200 animate-pulse"></div>
            <div class="h-3 w-20 rounded bg-gray-300 mt-4 mb-1 animate-pulse"></div>
            <div class="h-8 w-full rounded-lg bg-gray-200 animate-pulse"></div>
            <div class="h-8 w-full rounded-lg bg-gray-200 animate-pulse"></div>
            <div class="h-3 w-24 rounded bg-gray-300 mt-4 mb-1 animate-pulse"></div>
            <div class="h-8 w-full rounded-lg bg-gray-200 animate-pulse"></div>
            <div class="h-8 w-full rounded-lg bg-gray-200 animate-pulse"></div>
            <div class="h-3 w-16 rounded bg-gray-300 mt-4 mb-1 animate-pulse"></div>
            <div class="h-8 w-full rounded-lg bg-gray-200 animate-pulse"></div>
            <div class="h-8 w-full rounded-lg bg-gray-200 animate-pulse"></div>
            <div class="h-8 w-full rounded-lg bg-gray-200 animate-pulse"></div>
            <div class="h-3 w-20 rounded bg-gray-300 mt-4 mb-1 animate-pulse"></div>
            <div class="h-8 w-full rounded-lg bg-gray-200 animate-pulse"></div>
        </div>
    </div>
</ng-template>

<!-- Wrapper -->
<div class="flex flex-col flex-auto w-full min-w-0">

    <!-- Header -->
    <div class="fixed flex items-center w-full h-[82px] px-4 md:px-6 z-49 bg-[#f3f4f8]">
        <div class="flex flex-1 min-w-0 flex-wrap sm:pl-2 pr-44 it:pr-0">
            <div class="flex items-center justify-between w-full text-gray-600">
                <button *ngIf="this.backButtonVisible === true" class="m-auto relative rounded-xl cursor-pointer hover:bg-gray-200 p-3 mr-2"
                        (click)="previousPage()">
                    <mat-icon class="icon-size-6" [svgIcon]="'heroicons_outline:arrow-left'"></mat-icon>
                </button>
                <div class="w-full min-w-0 relative flex-col justify-start">
                    <div class="font-[500] sm:text-[22px] md:text-[24px] font-remote text-[#0f1419] leading-[22px] truncate min-w-0">{{ this.title }}</div>
                    <div class="font-[400] sm:text-[14px] font-inter text-gray-600 sm:hidden md:block">{{ this.descTitle }}</div>
                </div>
            </div>
        </div>
        <!-- Components -->
        <div class="flex fixed right-0 px-4 it:px-6">
            <button class="m-auto relative rounded-xl cursor-pointer hover:bg-gray-200 p-2 it:p-3"
                (click)="toggleNavigation('mainNavigation')">
                <mat-icon class="icon-size-6" [svgIcon]="'mat_solid:compare_arrows'"></mat-icon>
            </button>
            <notification-bell></notification-bell>
            <user></user>
        </div>
    </div>

    <!-- Content -->
    <div class="flex flex-col flex-auto bg-[#f3f4f8] mt-[82px]">
        <router-outlet *ngIf="true"></router-outlet>
    </div>

    <!-- Footer -->
    <!--<div class="relative flex flex-0 items-center justify-start w-full h-14 px-4 md:px-6 z-49 border-t bg-card dark:bg-transparent print:hidden">
        <span class="font-medium text-secondary">Atos8 &copy; {{currentYear}}</span>
    </div>-->

</div>
